import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { useSnackbar } from 'notistack';
import { CompaniesService } from 'api';
import { COMPANY_ZANBATO_MARKS_VALUATION_QUERY_KEY } from 'common/constants/services/companies';

const useGetCompanyZanbatoMarksValuation = (companyId: number | undefined) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading, isError } = useQuery({
    enabled: !isNil(companyId),
    queryFn: () => CompaniesService.apiCompaniesZanbatoMarksValuationRead(companyId as number),
    queryKey: [COMPANY_ZANBATO_MARKS_VALUATION_QUERY_KEY, companyId],
    retry: false,
  });

  useEffect(() => {
    if (isError) {
      enqueueSnackbar('An error occurred loading Reported Marks Valuation data.', { variant: 'error' });
    }
  }, [isError, enqueueSnackbar]);

  return { data, isLoading, isError };
};

export default useGetCompanyZanbatoMarksValuation;
